import { useState } from "react";
import { X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";

export function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox.");
    } catch (e) {
      toast.error(apiErrorMessage(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-foreground text-background print:hidden" data-testid="email-verification-banner">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4 px-6 py-2.5">
        <p className="font-mono text-[11px] uppercase tracking-[0.14em]">
          Please verify your email address to secure your account.
        </p>
        <div className="flex items-center gap-4 shrink-0">
          <button
            onClick={handleResend}
            disabled={sending}
            className="font-mono text-[11px] uppercase tracking-[0.14em] underline hover:no-underline disabled:opacity-60"
            data-testid="email-verification-resend-button"
          >
            {sending ? "Sending…" : "Resend Email"}
          </button>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss verification reminder"
            data-testid="email-verification-dismiss-button"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
